import * as React from 'react'

import { Box, Button, List, Skeleton, Text } from '@factorialco/deprecated-design-system'
import { EvaluationFormListItemFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { ListItem } from './ListItem'

interface Props {
  evaluationForms: EvaluationFormListItemFragment[]
  onNewTemplateClick: () => void
}

export function EvaluationFormTemplatesList({ evaluationForms, onNewTemplateClick }: Props) {
  if (evaluationForms.length === 0) {
    return (
      <Box alignItems="center" justifyContent="center" height="full" gap="s16">
        <Text.Normal weight="medium">
          {i18n.t('ats.evaluation_forms.settings.placeholder')}
        </Text.Normal>
        <Button onClick={onNewTemplateClick}>
          {i18n.t('ats.evaluation_forms.settings.new_template')}
        </Button>
      </Box>
    )
  }

  return (
    <List>
      {evaluationForms.map((evaluationForm) => (
        <ListItem
          key={`${evaluationForm.id}-${evaluationForm.name}`}
          evaluationForm={evaluationForm}
        />
      ))}
    </List>
  )
}

function EvaluationFormTemplatesListSkeleton() {
  return (
    <List>
      <List.ClickableItem>
        <List.Title>
          <Skeleton width="s200" height="s12" />
        </List.Title>

        <List.ActionItem>
          <Skeleton width="s32" height="s32" />
        </List.ActionItem>
      </List.ClickableItem>
      <List.ClickableItem>
        <List.Title>
          <Skeleton width="s300" height="s12" />
        </List.Title>

        <List.ActionItem>
          <Skeleton width="s32" height="s32" />
        </List.ActionItem>
      </List.ClickableItem>
      <List.ClickableItem>
        <List.Title>
          <Skeleton width="s120" height="s12" />
        </List.Title>

        <List.ActionItem>
          <Skeleton width="s32" height="s32" />
        </List.ActionItem>
      </List.ClickableItem>
    </List>
  )
}

EvaluationFormTemplatesList.Skeleton = EvaluationFormTemplatesListSkeleton
